import React, {memo} from "react";

import {formatDistanceToNow} from "../../../utils";
import {useInterval} from "../../hooks/useInterval";

interface Props {
    date: string | number | Date;
    interval?: number;
    includeSeconds?: boolean;
}

const FormatTimeToNow: React.FC<Props> = ({date, interval = 10_000, includeSeconds = true}) => {
    const [format, setFormat] = React.useState<string>(formatDistanceToNow(date, includeSeconds));

    useInterval(() => {
        setFormat(formatDistanceToNow(date, includeSeconds));
    }, interval);

    return <>{format}</>;
};

export default memo(FormatTimeToNow);
